import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TableDefaultService } from './table-default.service';
import { Status, StatusValue } from '../interface/status-filter.interface';
import {
  ArquivoVisual,
  FileManagerConfig,
} from '../file-manager/file-manager.interface';
import { AuthService } from '../../services/auth/auth.service';
import { UserService } from '../../services/user/user.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-table-default',
  templateUrl: './table-default.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*', overflow: 'hidden' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ),
    ]),
  ],
  styleUrls: ['./table-default.component.scss'],
})
export class TableDefaultComponent implements OnChanges, OnInit {
  private readonly situacaoPrazoLabels: Record<string, string> = {
    ENTREGUE_NO_PRAZO: 'Entregue no prazo',
    ENTREGUE_FORA_DO_PRAZO: 'Entregue fora do prazo',
  };
  // =========================================================================
  //                       Propriedades de Input e Output
  // =========================================================================
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @Input() dataSource!: MatTableDataSource<any> | any[] | any;
  @Input() displayedColumns: string[] = [];
  @Input() arrayStatus!: [
    { label: string; property: string; selected: boolean },
  ];
  @Input() sortState: any;
  @Input() screenWidth: number = 1025;
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @Input() customClassFilters: boolean = false;
  @Input() pageIndex: number = 0;
  @Input() totalPages: number = 1;
  @Input() criterios: any = [];
  @Input() actionDeleteLotes: string = '';
  @Input() expansivel: boolean = false;
  @Input() restoreExpandedId: string | null = null;
  @Input() listaStatus: Status[] = [];
  @Input() columnConfig: {
    columnDef: string;
    header: string;
    property?: string;
    pipe?: 'date' | 'uppercase' | 'lowercase';
    custom?: boolean;
    customTd?: boolean;
  }[] = [];
  @Input() totalElements: number = 0;
  @Input() pageSize: number = 10;
  @Input() from: string = '';
  @Input() status: boolean = false;
  @Input() alterarStatus: boolean = false;
  @Input() filterStatus: boolean = false;
  @Input() filterCustom: boolean = false;
  @Input() btnFilterDefault: boolean = true;
  @Input() visualizar: boolean = false;
  @Input() isSoloConcessionaria: boolean = true;
  @Input() vincular: boolean = false;
  @Input() criar: boolean = false;
  @Input() editar: boolean = false;
  @Input() editing: boolean = false;
  @Input() isMainList: boolean = false;
  @Input() excluir: boolean = false;
  @Input() assinar: boolean = false;
  @Input() acoes: boolean = false;
  @Input() importar: boolean = false;
  @Input() clonar: boolean = false;

  @Input() ordenacao: boolean = true;
  @Input() filtros: boolean = false;
  @Input() filtro: boolean = true;
  @Input() textFilter: boolean = true;
  @Input() hasBindUser: boolean = false;
  @Input() textButtonCreate: string = 'Adicionar';
  @Input() criteriosLabels: { [key: string]: string } = {};
  @Input() ariaLabel: string = 'Campo para busca';
  @Input() placeholder: string = 'Buscar';
  @Input() filterData: any;
  // Novos Inputs para o filtro personalizável
  @Input() customFilterArray: any[] = [];
  @Input() customFilterTitle: string = 'Filtrar';

  @Input() fileConfig: FileManagerConfig = {
    permitirUpload: false,
    permitirBaixarTodos: false,
    permitirReiniciar: false,
    modoEdicao: false, // Mude para false para ver o ícone de download em vez de lixeira
  };

  @Output() sortChange = new EventEmitter<string>();
  @Output() create = new EventEmitter<number>();
  @Output() edit = new EventEmitter<number>();
  @Output() delete = new EventEmitter<number>();
  @Output() view = new EventEmitter<number>();
  @Output() viewInformacoesComplementares = new EventEmitter<number>();
  @Output() associate = new EventEmitter<number>();
  @Output() viewAnalise = new EventEmitter<{}>();
  @Output() sign = new EventEmitter<{}>();
  @Output() import = new EventEmitter<number>();
  @Output() clone = new EventEmitter<number>();
  @Output() activate = new EventEmitter<number>();
  @Output() inactivate = new EventEmitter<number>();
  @Output() openHistory = new EventEmitter<number>();
  @Output() bindUser = new EventEmitter<number>();
  @Output() openFilter = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() filterText = new EventEmitter<string>();
  @Output() criterioRemoved = new EventEmitter<{}>();
  @Output() filterStatusChanged = new EventEmitter<{}>();
  @Output() transitionStatusChanged = new EventEmitter<{}>();
  @Output() rowExpanded = new EventEmitter<{}>();
  @Output() actionCheckbox = new EventEmitter<{}>();
  @Output() downloadFile = new EventEmitter<{}>();
  @Output() removeFile = new EventEmitter<{}>();
  // Novo Output para o filtro personalizável
  @Output() customFilterChanged = new EventEmitter<any[]>();
  // Suporte a abas
  @Input() tabs: { label: string; value: string }[] = [];
  @Input() activeTab: string = '';
  @Output() tabChange = new EventEmitter<string>();
  @Output() disciplineAction = new EventEmitter<{
    action: string;
    row: any;
    discipline: any;
    transicaoId?: string;
    transicaoNome?: string;
  }>();
  @Output() analiseDisciplinaAction = new EventEmitter<any>();
  @Output() analiseExecutivoAction = new EventEmitter<{
    action: string;
    row: any;
    disciplina: any;
    transicaoId?: string;
    transicaoNome?: string;
  }>();
  checkAllControl = new FormControl(false);
  itemsSelecteds: number = 0;
  checkboxAction: string = '';
  usuarioLogado: any;
  // =========================================================================
  //                       Propriedades Internas e Estado
  // =========================================================================
  expandedElement: any | null = null;
  appliedFilters: any = [];

  resetAction: boolean = false;
  // =========================================================================
  //                         Hooks do Ciclo de Vida
  // =========================================================================
  constructor(
    private tableDefaultService: TableDefaultService,
    private authService: AuthService,
    private userService: UserService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.dataSource.data.forEach((item: any) => (item.selected = false));
    if (this.from == 'form-projetos') {
      this.dataSource.data.forEach((item: any) => (item.edit = false));
    }
    this.checkAllControl.valueChanges.subscribe((isChecked: any) => {
      this.checkAllInPage(isChecked);
    });
    this.tableDefaultService.statusBooleano$.subscribe(
      (novoStatus: boolean) => {
        if (novoStatus) {
          this.dataSource.data.forEach((item: any) => (item.edit = false));
        }
      },
    );
    this.loadUserInfo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['restoreExpandedId'] && this.restoreExpandedId) {
      const row = this.dataSource?.data?.find(
        (r: any) => r.id === this.restoreExpandedId,
      );
      if (row) {
        this.expandedElement = row;
        this.rowExpanded.emit(row);
      }
    }
    if (changes['totalElements']) {
      this.itemsSelecteds = 0;
      this.checkAllControl.patchValue(false);
      this.dataSource.data.forEach((item: any) => (item.selected = false));
    }
    if (changes['actionDeleteLotes']) {
      let currentValue = changes['actionDeleteLotes'].currentValue;
      if (currentValue == 'cancelado' || currentValue == 'removido') {
        this.itemsSelecteds = 0;
        this.checkAllControl.patchValue(false);
        this.dataSource.data.forEach((item: any) => (item.selected = false));
        this.checkboxAction = '';
      }
      if (currentValue == 'impedido') {
        this.checkboxAction = '';
      }
    }
  }
  // =========================================================================
  //                               Métodos Públicos
  // =========================================================================
  onSortChange(field: string) {
    this.sortChange.emit(field);
    this.itemsSelecteds = 0;
    this.checkAllControl.patchValue(false);
  }

  emitEvent(event: EventEmitter<number>, id: number, row?: any, type?: string) {
    if (this.from == 'form-projetos' && type == 'edit') {
      this.dataSource.data.forEach((item: any) => (item.edit = false));
      row.edit = true;
    }

    if (this.from == 'view-relatorio-vinculados') {
      event.emit(row.relatorioContratual.id);
    } else if (this.from == 'analises-projeto-funcional' && event === this.edit) {
      event.emit(row.idAnaliseProjeto);
    } else {
      event.emit(id);
    }
  }
  emitEventText(event: EventEmitter<{}>, txt: string, dataSource?: any) {
    const data = {
      txt: txt,
      data: dataSource,
    };
    event.emit(data);
  }
  emitSignEvent(id: string, userId: string) {
    const data = {
      id: id,
      userId: userId,
    };
    this.sign.emit(data);
  }

  filterStatusChange() {
    let statusSelecteds;
    if (this.listaStatus.length > 0) {
      statusSelecteds = this.getArrayStatusSelected();
    } else {
      statusSelecteds = this.arrayStatus.filter(
        (item) => item.selected === true,
      );
    }

    this.filterStatusChanged.emit(statusSelecteds);
  }
  getStatusIcon(valor: string, isSelected: boolean = true): string {
    if (!isSelected) return 'assets/table/status-gray.svg';

    const icons: Record<string, string> = {
      [StatusValue.PENDENTE_COMPROVACAO]: 'assets/table/status-yellow.svg',
      [StatusValue.COMPROVACAO_ENVIADA]: 'assets/table/status-green.svg',
      [StatusValue.PARAMETRO_ATESTADO]: 'assets/table/status-green.svg',
      [StatusValue.EM_ANALISE]: 'assets/table/status-blue.svg',
      [StatusValue.AGUARDANDO_COMPLEMENTACAO_INFORMACOES]:
        'assets/table/status-red.svg',
      AGUARDANDO_ANALISE: 'assets/table/status-yellow.svg',
      AGUARDANDO_APROVACAO: 'assets/table/status-blue.svg',
      AGUARDANDO_REVISAO: 'assets/table/status-purple.svg',
      ATENDIDO: 'assets/table/status-green.svg',
      ATIVO: 'assets/table/status-green.svg',
      CANCELADO: 'assets/table/status-green.svg',
      EM_PROCESSO_DE_CADASTRO: 'assets/table/status-yellow.svg',
      EM_ANALISE_INTERNA: 'assets/table/status-blue.svg',
      EM_ANALISE_SUPERVISORA: 'assets/table/status-blue.svg',
      EM_ANALISE_RELATORIO: 'assets/table/status-blue.svg',
      CONCLUIDO: 'assets/table/status-green.svg',
      NAO_OBJECAO: 'assets/table/status-green.svg',
      NAO_OBJECAO_COM_RESSALVAS: 'assets/table/status-green.svg',
    };

    return icons[valor] || 'assets/table/status-gray.svg';
  }
  transitionStatusChange(id: string, status: string, data: any) {
    const values = {
      data: data,
      transicaoId: id,
      transicaoNome: status,
    };
    this.transitionStatusChanged.emit(values);
  }

  // Novo método para emitir a alteração do filtro personalizável
  filterCustomChange(item: any) {
    const selectedItems = this.customFilterArray.filter((i) => i.selected);
    this.customFilterChanged.emit(selectedItems);
  }

  getValue(row: any, path?: string, pipe?: string): any {
    if (!path) return '';

    const value = path.split('.').reduce((acc, part) => acc?.[part], row);

    if (pipe === 'date') {
      return value ? new Date(value).toLocaleDateString('pt-BR') : '';
    }

    if (pipe === 'uppercase') return value?.toString().toUpperCase();
    if (pipe === 'lowercase') return value?.toString().toLowerCase();

    return value;
  }

  pageChangeEvent(event: PageEvent) {
    this.pageChange.emit(event);
  }

  getSingularOrPlural(medida: any, valor: any) {
    let result;
    return result;
  }

  getMedidaFormatada(valor: any, medida: any): string {
    if (!medida || valor == null) return '';
    const defaultMedida = medida;
    const medidaLower = medida.toLowerCase();

    const singularMap: any = {
      dias: 'Dia',
      meses: 'Mês',
      anos: 'Ano',
      horas: 'Hora',
    };

    if (valor === 1 || valor < 1) {
      return singularMap[medidaLower] || medidaLower;
    }

    return defaultMedida;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.length >= 3 || filterValue.length === 0) {
      this.filterText.emit(filterValue);
    }
  }

  openModalFilters(popoverRef?: any) {
    this.openFilter.emit(popoverRef);
  }

  openViewAnalise(row: any, idAnalise: any) {
    const data = {
      data: row,
      idAnalise: idAnalise,
    };
    this.viewAnalise.emit(data);
  }

  removerCriterio(criterio: string) {
    const data = {
      criterio: criterio,
    };
    this.criterios = this.criterios.filter((c: any) => c !== criterio);
    this.criterioRemoved.emit(data);
  }
  clearFiltersAndRefresh() {
    this.criterios.forEach((criterio: string) => {
      this.removerCriterio(criterio);
    });
  }
  getFilterDisplayValue(criterio: string): string {
    if (!this.filterData?.value) {
      return '';
    }

    if (this.from == 'users') {
      return this.filterData.value.labelPerfilSelecionado || '';
    }

    if (this.from == 'feriados') {
      return this.filterData.get('anos')?.value?.join(', ') || '';
    }

    const value = this.filterData.value[criterio];

    if (criterio === 'situacaoPrazo' && typeof value === 'string') {
      return this.situacaoPrazoLabels[value] || value;
    }

    if (Array.isArray(value)) {
      return value.join(', ');
    }

    return value ?? '';
  }
  getLabelCriterio(criterio: string): string {
    return this.criteriosLabels[criterio] || 'Critério Desconhecido';
  }

  toggleRow(row: any) {
    this.expandedElement = this.expandedElement === row ? null : row;
    if (this.expandedElement === row) {
      this.rowExpanded.emit(this.expandedElement);
    }
  }

  getArrayStatusSelected(): any {
    if (this.listaStatus.length > 0) {
      return this.listaStatus.filter((item) => item.selecionado);
    }
    return this.arrayStatus.filter((item) => item.selected === true);
  }

  clearStatusSelecteds() {
    let statusSelecteds: any;
    if (this.listaStatus.length > 0) {
      this.listaStatus.forEach((item) => (item.selecionado = false));
      statusSelecteds = [];
    } else {
      this.arrayStatus.forEach((item) => (item.selected = false));
      statusSelecteds = this.arrayStatus.filter(
        (item) => item.selected === true,
      );
    }

    this.filterStatusChanged.emit(statusSelecteds);
  }

  // Novo método para obter os itens selecionados do filtro personalizável
  getArrayCustomSelected() {
    return this.customFilterArray.filter((item) => item.selected === true);
  }

  // Novo método para limpar os itens selecionados do filtro personalizável
  clearCustomSelecteds() {
    this.customFilterArray.forEach((item) => (item.selected = false));
    const selecteds = this.customFilterArray.filter(
      (item) => item.selected === true,
    );
    this.customFilterChanged.emit(selecteds);
  }

  // Método para obter o primeiro município
  getFirstMunicipio(municipios: any[]): string {
    return municipios && municipios.length > 0
      ? `${municipios[0].nome} / ${municipios[0].uf}`
      : '';
  }

  // Método para obter a lista completa de municípios para o tooltip
  getMunicipiosTooltip(municipios: any[]): string {
    return municipios && municipios.length > 0
      ? municipios.map((m) => m.nome).join(', ')
      : '';
  }
  // =========================================================================
  //                               Métodos Privados
  // =========================================================================
  isMenuOpen() {
    return this.menuTrigger?.menuOpen;
  }

  isExpansionDetailRow = (index: number, row: any) =>
    row.hasOwnProperty('detailRow');
  isNormalRow = (index: number, row: any): boolean => !row.detailRow;
  isDetailRow = (index: number, row: any): boolean => {
    return row.detailRow === true;
  };

  checkAllInPage(isChecked: boolean) {
    // isChecked será o valor atual do checkbox (true ou false)

    // Sincroniza todos os itens da linha com o novo estado
    if (isChecked) {
      this.checkboxAction = '';
    } else {
      this.checkboxAction = '';
    }
    this.dataSource.data.forEach((item: any) => (item.selected = isChecked));

    // Lógica para contar os itens selecionados
    let itemsTrue = this.dataSource.data.filter(
      (item: any) => item.selected == true,
    );
    this.itemsSelecteds = itemsTrue.length;

    // Força a detecção de mudança para atualizar as linhas e a contagem
    // this.cdRef.detectChanges();
  }
  itemSelected() {
    let itemsTrue = this.dataSource.data.filter(
      (item: any) => item.selected == true,
    );
    this.itemsSelecteds = itemsTrue.length;
    if (this.itemsSelecteds > 0) {
      this.checkboxAction = '';
    }
    if (this.itemsSelecteds == this.dataSource.data.length) {
      this.checkAllControl.patchValue(true);
    }
  }

  filtrarEFormatarArquivos(
    arquivos: any[],
    tipo: 'imagem' | 'documento',
  ): any[] {
    if (!arquivos || arquivos.length === 0) return [];

    const filtrados = arquivos.filter((f) => {
      const isImage = /\.(png|jpg|jpeg|gif)$/i.test(f.nomeArquivo);
      return tipo === 'imagem' ? isImage : !isImage;
    });

    return filtrados.map((f) => ({
      id: f.id,
      idExterno: f.idExterno,
      nome: f.nomeArquivo,
      url: f.sasURL || 'assets/img-placeholder.png',
      arquivoOriginal: f,
    }));
  }

  handleItemAction(item: ArquivoVisual) {
    if (this.fileConfig.modoEdicao) {
      this.removeFile.emit(item);
      return;
    }

    if (item.url) {
      window.open(item.url, '_blank');
      return;
    }

    this.downloadFile.emit(item);
  }
  toggleAnexos(interacao: any) {
    interacao.exibirAnexos = !interacao.exibirAnexos;
  }
  getArquivosPorTipo(
    arquivos: any[],
    tipoAnexo: 'GERAL' | 'ART',
  ): ArquivoVisual[] {
    if (!arquivos || arquivos.length === 0) {
      return [];
    }

    return arquivos
      .filter((item) => item.tipoAnexo === tipoAnexo)
      .map((item) => ({
        nome: item.nomeArquivo,
        url: item.sasURL,
        isImagem: /\.(png|jpg|jpeg|gif|bmp|webp|svg)$/i.test(
          item.nomeArquivo || '',
        ),
      }));
  }
  getImagensArquivosPorTipo(
    arquivos: any[],
    tipoAnexo: 'GERAL' | 'ART',
  ): ArquivoVisual[] {
    return this.getArquivosPorTipo(arquivos, tipoAnexo).filter(
      (item) => item.isImagem,
    );
  }
  getDocumentosArquivosPorTipo(
    arquivos: any[],
    tipoAnexo: 'GERAL' | 'ART',
  ): ArquivoVisual[] {
    return this.getArquivosPorTipo(arquivos, tipoAnexo).filter(
      (item) => !item.isImagem,
    );
  }
  baixarTodosArquivos(arquivos: any[]) {
    if (!arquivos || arquivos.length === 0) {
      this.toastService.showError('Nenhum anexo disponível para download.');
      return;
    }

    arquivos.forEach((arquivo: any, index: number) => {
      setTimeout(() => {
        if (arquivo?.sasURL) {
          window.open(arquivo.sasURL, '_blank');
        }
      }, index * 400);
    });
  }
  loadUserInfo() {
    const userId: any = this.authService.getUserIdFromToken();
    this.userService.getMenuUsuario(userId).subscribe((response: any) => {
      this.usuarioLogado = response.id;
    });
  }

  isUsuarioLogado(usuarioId: any) {
    if (usuarioId == this.usuarioLogado) {
      return true;
    } else {
      return false;
    }
  }

  get isAnalisesProjetoFrom(): boolean {
    return (
      this.from === 'analises-projeto-funcional' ||
      this.from === 'analises-projeto-executivo'
    );
  }

  podeEditar(row: any): boolean {
    if (this.buttonEdicaoDisabled) {
      return true;
    }

    if (this.from === 'analise-projeto-funcional') {
      const estaConcluido = row?.statusAnaliseProjeto === 'Concluído';

      return estaConcluido;
    }

    if (this.from === 'analises-projeto-funcional') {
      return row?.statusAtual === 'Concluído';
    }

    if (
      this.from === 'listar-projetos' ||
      this.from === 'listar-projetos-executivo'
    ) {
      const statusNaoInicial = row?.status?.statusAtual?.tipo !== 'Inicial';
      const tipoEntidadeNaoPermitido = !this.isSoloConcessionaria;
      return statusNaoInicial || tipoEntidadeNaoPermitido;
    }

    return false;
  }
}
